<template>
  <v-container fill-height grid-list-xl>
    <v-layout justify-center wrap>
      <section
        id="causeSectionHeader"
        style="position:relative;min-width:100vw;height:500px;top: -12px;"
      >
        <v-img
          height="100%"
          position="center center"
          :src="require('../assets/Headers/approved good cause-05-01.jpg')"
          class="hidden-xs-only"
        />
        <v-img
          height="300"
          position="center center"
          :src="require('../assets/Headers/approved good cause-05-01.jpg')"
          class="hidden-sm-and-up"
        />
      </section>

      <v-container grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex xs12 style="text-align: center">
            <h3
              style="font-weight: bold !important;font-family: 'Aleo' !important;font-size: 30pt !important;color: black;"
            >Approved Good Causes</h3>
          </v-flex>
          <v-flex xs12 style="text-align: left">
            <p>Below is a list of school based or community organisations that agree to put their contributions towards strengthening the well-being of young people in our communities. You can select a specific cause to directly benefit when you use our suppliers.</p>
          </v-flex>
          <v-flex
            v-for="goodCause in goodCauses"
            :key="goodCause.id"
            xs12
            sm4
            class="goodCauseCard"
            style="height: 410px;"
          >
            <v-card style="background: white; height: 100%;" @click="loadGoodCause(goodCause.id)">
              <div style=" width: 100%; padding-top: 20px;">
                <v-img
                  v-if="goodCause.imageUrl"
                  :src="goodCause.imageUrl"
                  width="80%"
                  style="margin: auto;"
                >
                  <v-container fill-height fluid>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox />
                    </v-layout>
                  </v-container>
                </v-img>
                <v-img
                  v-else
                  src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/upstream-logo-padded.png?alt=media&token=748dcd0a-a617-4173-b33b-57aed67c4bc6"
                  height="200px"
                />
              </div>
              <v-card-title>
                <div style="min-height: 53px; text-align: left; margin: auto;">
                  <div
                    class="title"
                    style="font-weight: bold !important; font-family: 'Aleo' !important; font-size: 15pt !important; color: #4cc7e8; margin-bottom: 0 !important; min-height: 60px; "
                  >{{ goodCause.name }}</div>
                  <div class="nl2br">{{ goodCause.shortSummary }}</div>
                </div>
              </v-card-title>

              <!--              <v-divider/>-->
              <!--              <v-card-actions style="height:44px">-->
              <!--                <v-btn<a :href="`http://${goodCause.website}`">{{ goodCause.website }}</a>-->
              <!--              </v-card-actions>-->
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import { sendGeneralEnquiry } from "@/fireinit.js";

  export default {
    data: () => ({
      formData: {},
      emailFormConfirmation: false
    }),
    computed: {
      ...mapGetters({
        user: "user",
        goodCauses: "goodCauses/approved"
      })
    },
    methods: {
      loadGoodCause(goodCauseId) {
        this.$router.push(`/GoodCauses/${goodCauseId}`);
      }
    }
  };
</script>

<style>
  .application {
    background-color: white !important;
  }

  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
  }

  .video-container iframe,
  .video-container object,
  .video-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .nl2br {
    white-space: pre-line;
  }

  @media only screen and (max-width: 600px) {
    section#causeSectionHeader {
      height: 100% !important;
    }
  }

  @media only screen and (min-width: 1904px) {
    .pageContent {
      max-width: 1200px;
    }
  }

  .display-3 {
    font-family: "Aleo" !important;
  }

  .headline {
    font-family: "Aleo" !important;
  }

  .subheading {
    font-weight: bold;
  }

  @media screen and (max-width: 600px) {
    .goodCauseCard {
      height: 500px !important;
    }
  }

  @media screen and (max-width: 400px) {
    .goodCauseCard {
      height: 400px !important;
    }
  }
</style>
